import { render, staticRenderFns } from "./warehouseSelectedItems.vue?vue&type=template&id=878937aa"
import script from "./warehouseSelectedItems.vue?vue&type=script&lang=js"
export * from "./warehouseSelectedItems.vue?vue&type=script&lang=js"
import style0 from "./warehouseSelectedItems.vue?vue&type=style&index=0&id=878937aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports